import { cn } from "@/shared/lib/cn";

interface BrandMarkProps {
  /** Rendered size in px (the mark is square). */
  size?: number;
  className?: string;
  /** Accessible label; empty string hides it from AT (decorative use). */
  label?: string;
}

/**
 * The PayGate LogistiX "P" arrow mark — a single stroked path with the brand
 * gradient (teal → blue → violet), recreated as inline SVG so it stays crisp
 * at every size/DPR and ships no bitmap. The same geometry is duplicated in
 * `public/favicon.svg` (browser tab icon) — keep the two in sync.
 */
export function BrandMark({ size = 32, className, label = "PayGate LogistiX" }: BrandMarkProps) {
  return (
    <svg
      viewBox="0 0 640 680"
      width={size}
      height={size}
      className={cn("shrink-0 select-none", className)}
      role={label ? "img" : undefined}
      aria-label={label || undefined}
      aria-hidden={label ? undefined : true}
    >
      <defs>
        <linearGradient id="pg-brand-gradient" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#35E2C2" />
          <stop offset="45%" stopColor="#2F7CF6" />
          <stop offset="100%" stopColor="#7C3AED" />
        </linearGradient>
      </defs>
      <path
        d="M170 585 L170 95 L495 300 L300 470"
        fill="none"
        stroke="url(#pg-brand-gradient)"
        strokeWidth="96"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
